<template>
  <div class="form" v-if="formActive">
    <div class="field" v-if="options.phone">
      <p>{{options.phone.name}}</p>
      <input type="text" placeholder="请输入手机号" name="whgphone" v-model="phone" v-validate:phone="[{'required':true,'msg':'手机号不能为空'},{'mobile':true,'msg':'手机号格式错误'}]">
    </div>
    <div class="field vertCode" v-if="false">
      <p>{{options.vert.name}}</p>
      <input type="text" placeholder="图形验证码" name="whgpsw" v-model="captcha" v-validate:captcha="[{'required':true,'msg':'图形验证码不能为空'}]">
      <div class="vert">
        <img src="http://app.qdsnqwhg.cn/captcha/create" @click="reloadCaptcha($event)">
      </div>
    </div>
    <div class="field vertCode" v-if="options.code&&options.code.name">
      <p>{{options.code?options.code.name:''}}</p>
      <input type="text" placeholder="短信验证码" name="whgphone" v-model="code" v-validate:code="[{'required':true,'msg':'短信验证码不能为空'}]">
      <div class="vert code" @click="getCapt">
        {{codeText}}
      </div>
    </div>
    <div class="field" v-if="options.psw">
      <p>{{options.psw.name}}</p>
      <input type="password" placeholder="请输入密码" name="whgpsw" v-model="psw" v-validate:psw="[{'required':true,'msg':'密码不能为空'}]">
    </div>
    <div class="field repeat" v-if="options.repsw">
      <p>{{options.repsw.name}}</p>
      <input type="password" placeholder="请再次输入密码" v-model="repsw">
    </div>
    <div class="notice" v-if="options.notice">
      <label for="checkbox">
        <input type="checkbox" id="checkbox" v-model="checked">
        <a>《法律声明和隐私政策》</a>
      </label>
    </div>
    <div class="btn" @click="submit">{{options.btn.name}}</div>
  </div>
</template>

<script>
export default {
  inject: ['ajax'],
  props: ['options'],
  data() {
    return {
      phone: '',
      captcha: '',
      code: '',
      psw: '',
      repsw: '',
      checked: '',
      codeText: '获取验证码',
      sendFlag: false,
      formActive: true,
      capt: {},
      captCont: ''
    };
  },
  created() {

  },
  watch: {
    options() {
      this.$va = null
      this.formActive = false
      this.$nextTick(() => {
        this.formActive = true
      })
    }
  },
  mounted() {
    let _this = this
    let sendCode = document.getElementById('code')
    this.ajax('/captcha/create', 'get', '', res => {
      this.session = res.data.sessionid
      initGeetest({
        // 以下配置参数来自服务端 SDK
        gt: res.data.data.gt,
        challenge: res.data.data.challenge,
        offline: !(!!res.data.data.success),
        new_captcha: !!res.data.data.new_captcha,
        product: 'bind'
      }, function (captchaObj) {
        captchaObj.onReady(function () {
          //验证码ready之后才能调用verify方法显示验证码
        }).onSuccess(function () {
          _this.capt = captchaObj.getValidate()
          _this.sendCode()
        }).onError(function () { })
        _this.captCont = captchaObj
        // 这里可以调用验证实例 captchaObj 的实例方法
      })
    })


  },
  methods: {
    // 图片验证码
    reloadCaptcha(e) {
      e.target.src = e.target.src
    },
    //提交
    submit() {
      if (this.options.notice && !this.checked) {
        this.$toast('请先阅读《法律声明和隐私政策》', 2500)
        return
      }
      if (!this.$va.checkAll().checkFlag) {
        this.$toast(this.$va.checkAll().msg, 2500)
        return
      } else {
        let formData = {
          tel: this.phone,
          password: this.psw,
          msg_captcha: this.code
        }
        this.$emit('carryData', formData)
      }
    },
    getCapt() {
      if (this.phone) {
        this.captCont.verify()
      } else {
        this.$toast('手机号为必填')
      }

    },
    sendCode() {
      if (!this.phone) {
        this.$toast('手机号为必填')
        return
      }
      if (!this.sendFlag) {
        this.sendFlag = true
        this.capt.tel = this.phone
        this.ajax(`/api/reg/sendmsgcaptcha`, 'post', this.$qs.stringify(this.capt), res => {
          let total = 60
          let timer = setInterval(() => {
            total--
            if (total <= 0) {
              clearInterval(timer)
              this.codeText = '重新获取'
              this.sendFlag = false
            } else {
              this.codeText = `${total.toString()[1] ? total : '0' + total}s`
            }
          }, 1000)
        }, () => {
          this.sendFlag = false
        })
      }

    }
  },
};
</script>

<style scoped>
.field {
  width: 100%;
  border-bottom: 1px solid #d7d7d7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3px;
  position: relative;
}

.field > p {
  color: #111;
  font-size: 1em;
  cursor: default;
  width: 80px;
  min-width: 80px;
  line-height: 20px;
}

.field > input {
  line-height: 24px;
  font-size: 1em;
  width: 300px;
  color: #a3a3a3;
  padding: 20px 3px;
  flex: 1;
}

.repeat > input {
  width: 250px;
}

.repeat > span {
  width: auto;
}

.vertCode > input {
  /* width: 80px; */
  width: calc(100% - 190px);
}

.vert {
  width: 100px;
  height: 54px;
  border: 1px solid #dfdfdf;
  cursor: pointer;
}

.vert img {
  width: 100%;
  height: 100%;
}

.code {
  font-size: 1em;
  line-height: 54px;
  text-align: center;
  color: #a3a3a3;
  cursor: pointer;
}

.btn {
  color: #fff;
  background: #4ba6ff;
  font-size: 1.2em;
  text-align: center;
  line-height: 2.5em;
  margin-top: 36px;
  width: 100%;
}

.notice {
  font-size: 0.8em;
  color: #4ba6ff;
  margin-top: 15px;
  margin-bottom: -30px;
}

@media only screen and (max-width: 750px) {
  .btn {
    font-size: 1em;
  }

  .repeat > input {
    width: 1.9rem !important;
  }
}
</style>